import * as sdk from 'matrix-js-sdk'

export type MatrixCredentials = {
  matrixUserId: string
  matrixAccessToken: string
  matrixDeviceId: string
  matrixHomeserver: string
}

export async function createMatrixClient(
  credentials: MatrixCredentials,
): Promise<sdk.MatrixClient> {
  let store: any

  // Use IndexedDB store on web for persistent cache across refreshes
  if (typeof globalThis.indexedDB !== 'undefined') {
    const {IndexedDBStore} = await import('matrix-js-sdk/lib/store/indexeddb')
    store = new IndexedDBStore({
      indexedDB: globalThis.indexedDB,
      localStorage: globalThis.localStorage,
      dbName: `matrix-store-${credentials.matrixUserId}`,
    })
  }

  const client = sdk.createClient({
    baseUrl: credentials.matrixHomeserver,
    accessToken: credentials.matrixAccessToken,
    userId: credentials.matrixUserId,
    deviceId: credentials.matrixDeviceId,
    store,
  })

  // startup() must be called after the store is assigned to the client
  if (store?.startup) {
    await store.startup()
  }

  return client
}
